import React, { useState } from 'react';
import { Container, Typography, Box, Tabs, Tab } from '@mui/material';
import Layout from '../../components/Layout';
import DeliveryFeeSimulatorSection from '../../components/manager/DeliveryFeeSimulatorSection';
import QuoteCreationSection from '../../components/manager/QuoteCreationSection';

const ManagerTools = () => {
  const [tabValue, setTabValue] = useState(0);

  return (
    <Layout>
      <Container maxWidth="lg">
        <Typography variant="h4" gutterBottom>
          Tools
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Calculators and utilities for pricing and operations.
        </Typography>

        <Tabs
          value={tabValue}
          onChange={(_, newValue) => setTabValue(newValue)}
          sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab label="Create Quote" />
          <Tab label="Delivery Fee Simulator" />
        </Tabs>

        <Box role="tabpanel" hidden={tabValue !== 0}>
          {tabValue === 0 && <QuoteCreationSection />}
        </Box>
        <Box role="tabpanel" hidden={tabValue !== 1}>
          {tabValue === 1 && <DeliveryFeeSimulatorSection />}
        </Box>
      </Container>
    </Layout>
  );
};

export default ManagerTools;
